/**
 * Contract status derivation constants.
 * Codes, descriptors (label/color/icon/tooltip-template), and event-name lists
 * consumed by `deriveContractStatus(document)`.
 */

export const STATUS_CODES = Object.freeze({
  SIGNED_COMPLETE: 'signed_complete',
  CLOSED_BY_DEADLINE: 'closed_by_deadline',
  CLOSED_BY_REFUSAL: 'closed_by_refusal',
  CANCELED_MANUAL: 'canceled_manual',
  AWAITING_SIGNATURES: 'awaiting_signatures',
  EXPIRED_BY_VALIDITY: 'expired_by_validity',
  FALLBACK_SIGNED: 'fallback_signed',
  FALLBACK_PENDING: 'fallback_pending',
  FALLBACK_CANCELED: 'fallback_canceled',
})

export const TERMINAL_NEGATIVE_STATUS_CODES = Object.freeze([
  STATUS_CODES.CLOSED_BY_DEADLINE,
  STATUS_CODES.CLOSED_BY_REFUSAL,
  STATUS_CODES.CANCELED_MANUAL,
  STATUS_CODES.EXPIRED_BY_VALIDITY,
  STATUS_CODES.FALLBACK_CANCELED,
])

export const STATUS_DESCRIPTORS = Object.freeze({
  [STATUS_CODES.SIGNED_COMPLETE]: {
    label: 'Assinado por todos',
    color: 'success',
    icon: 'mdi-check-circle',
    tooltipTemplate:
      'Contrato assinado por todos os signatários em {data_finalizacao}.',
  },
  [STATUS_CODES.CLOSED_BY_DEADLINE]: {
    label: 'Encerrado por prazo',
    color: 'danger',
    icon: 'mdi-clock-alert-outline',
    tooltipTemplate:
      'Prazo expirado em {deadline_at}; contrato encerrado automaticamente.',
  },
  [STATUS_CODES.CLOSED_BY_REFUSAL]: {
    label: 'Encerrado por recusa',
    color: 'danger',
    icon: 'mdi-close-octagon',
    tooltipTemplate:
      'Encerrado após recusa de {nome_signatario} em {data_recusa}.',
  },
  [STATUS_CODES.CANCELED_MANUAL]: {
    label: 'Cancelado manualmente',
    color: 'danger',
    icon: 'mdi-cancel',
    tooltipTemplate:
      'Cancelado manualmente em {data_cancelamento} por {usuario}.',
  },
  [STATUS_CODES.AWAITING_SIGNATURES]: {
    label: 'Aguardando assinatura',
    color: 'warning-new',
    icon: 'mdi-clock-outline',
    tooltipTemplate:
      'Aguardando assinatura de {n_signatarios} signatário(s); prazo até {deadline_at}.',
  },
  [STATUS_CODES.EXPIRED_BY_VALIDITY]: {
    label: 'Vigência expirada',
    color: 'danger',
    icon: 'mdi-calendar-remove',
    tooltipTemplate:
      'Contrato assinado, mas a vigência expirou em {data_fim_vigencia}.',
  },
  [STATUS_CODES.FALLBACK_SIGNED]: {
    label: 'Concluído',
    color: 'success',
    icon: 'mdi-check-circle-outline',
    tooltipTemplate: '',
  },
  [STATUS_CODES.FALLBACK_PENDING]: {
    label: 'Aguardando assinatura',
    color: 'warning',
    icon: 'mdi-clock-outline',
    tooltipTemplate: '',
  },
  [STATUS_CODES.FALLBACK_CANCELED]: {
    label: 'Documento cancelado',
    color: 'danger',
    icon: 'mdi-close-circle',
    tooltipTemplate: '',
  },
})

export const REFUSAL_EVENT_NAMES = ['refusal', 'sign_refusal', 'rejected']
export const CANCEL_EVENT_NAMES = ['cancel', 'document_cancel']
export const AUTO_CLOSE_EVENT_NAMES = ['auto_close']
export const SIGNED_EVENT_NAMES = ['sign', 'sign_complete']

export const CLICKSIGN_PROVIDER_ID = 1
